var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircusRightImage(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 218,
    height: 131,
    viewBox: "0 0 218 131",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M216.872 25.48C217.492 17 211.142 9.62 202.652 9",
    stroke: "#FFA940",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.191 87.9785L204.645 90.6035L207.27 95.15L211.816 92.525L209.191 87.9785Z",
    fill: "#FFA940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.125 10.9679L191.516 9.16211L189.71 13.7711L194.319 15.5768L196.125 10.9679Z",
    stroke: "#FFA940",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.38 45.7402L196.27 56.4702L206.12 52.0702L197.38 45.7402Z",
    fill: "#FFA940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.5214 33.7106C60.1285 33.7106 61.4314 32.4078 61.4314 30.8006C61.4314 29.1935 60.1285 27.8906 58.5214 27.8906C56.9142 27.8906 55.6113 29.1935 55.6113 30.8006C55.6113 32.4078 56.9142 33.7106 58.5214 33.7106Z",
    fill: "#FFA940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.65161 67.0395C10.3696 67.0395 10.9515 66.4574 10.9515 65.7394C10.9515 65.0215 10.3696 64.4395 9.65161 64.4395C8.93364 64.4395 8.35156 65.0215 8.35156 65.7394C8.35156 66.4574 8.93364 67.0395 9.65161 67.0395Z",
    stroke: "#FFA940",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.871 14.1292C161.887 14.1292 162.711 13.3054 162.711 12.2892C162.711 11.273 161.887 10.4492 160.871 10.4492C159.855 10.4492 159.031 11.273 159.031 12.2892C159.031 13.3054 159.855 14.1292 160.871 14.1292Z",
    stroke: "#FFA940",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.692 51.2705C172.312 51.2705 171.932 51.1305 171.642 50.8405C171.062 50.2605 171.062 49.3305 171.642 48.7505L174.352 46.0405C174.932 45.4605 175.862 45.4605 176.442 46.0405C177.022 46.6205 177.022 47.5505 176.442 48.1305L173.732 50.8405C173.452 51.1305 173.072 51.2705 172.692 51.2705Z",
    stroke: "#FFA940",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6523 86.83L44.5023 75.5",
    stroke: "#FFA940",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.6523 65.63L41.0023 65.5",
    stroke: "#FFA940",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.87 21.3594L159.02 34.5694",
    stroke: "#FFA940",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M205.101 110.86L177.611 98.8398",
    stroke: "#FFA940",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.302 26.2695L166.941 38.4295",
    stroke: "#FFA940",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.0806 123.309C50.8506 123.219 42.1807 123.309 42.1807 123.309L41.8007 122.189C41.8007 122.189 15.9907 122.819 9.02066 119.829C1.11066 116.439 -4.23939 112.979 5.22061 111.879C14.6806 110.779 7.89062 118.699 51.9806 118.699L52.0806 123.309Z",
    fill: "#D9480F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.574 48.672C129.44 47.1346 133.399 38.7103 131.416 29.8559C129.434 21.0014 122.26 15.0698 115.395 16.6072C108.529 18.1446 104.57 26.5688 106.553 35.4233C108.536 44.2777 115.709 50.2094 122.574 48.672Z",
    fill: "#FFD8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.2603 109.479L87.6202 113.849L85.7402 122.579C85.7402 122.579 90.5303 123.309 91.2603 123.309C91.9903 123.309 98.5403 121.849 98.5403 121.849L106.27 114.749L99.2603 109.479Z",
    fill: "#FFA940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.7704 84.1794C65.7704 84.1794 47.2904 99.6194 41.6504 103.289C36.0704 106.929 49.3004 109.569 49.3004 109.569L72.7003 100.379L65.7704 84.1794Z",
    fill: "#FFA940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.4397 92.3794L71.9697 101.839L62.5098 74.9094L76.3397 71.9994L95.2498 71.6694L117.03 85.0994L124.78 88.8294L97.9098 111.889L91.0098 101.849C91.6098 101.849 87.5598 93.3994 87.5598 93.3994",
    fill: "#FF922B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.951 107.299L166.621 90.2295L160.041 50.8894L153.671 44.4094C153.671 44.4094 142.301 41.4294 133.341 42.1594C124.381 42.8894 107.791 48.7395 107.791 48.7395C107.791 48.7395 110.131 77.4594 118.201 85.4594C126.271 93.4594 166.951 107.299 166.951 107.299Z",
    fill: "#FFA940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8896 117.599C11.696 117.599 12.3496 116.946 12.3496 116.139C12.3496 115.333 11.696 114.679 10.8896 114.679C10.0833 114.679 9.42969 115.333 9.42969 116.139C9.42969 116.946 10.0833 117.599 10.8896 117.599Z",
    stroke: "#FFA940",
    strokeWidth: 0.9762,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.381 40.7093C140.381 40.7093 138.101 19.2793 126.551 13.0593C117.091 7.96934 104.721 9.41934 99.6207 21.7893C94.5307 34.1593 98.8907 49.4393 98.8907 49.4393L117.081 47.2593C117.081 47.2593 107.591 39.1293 107.261 30.1593C106.931 21.1893 115.631 18.8793 115.631 18.8793C115.631 18.8793 124.981 16.3693 127.941 27.8093C130.901 39.2493 127.271 45.7993 127.271 45.7993L140.381 40.7093Z",
    fill: "#F76707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.51 48.7394C104.29 54.5894 81.8003 59.6294 81.8003 59.6294L63.9702 47.2594C63.9702 47.2594 64.7003 48.7194 61.0603 50.8994C57.4203 53.0794 55.2402 53.0794 55.2402 53.0794L76.3402 71.9994H112.73L108.51 48.7394Z",
    fill: "#FFA940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.3009 109.569C49.3009 109.569 38.5008 107.589 40.3208 102.899C40.3208 102.899 39.2309 101.119 32.6809 106.939C26.1309 112.759 18.8508 111.309 18.8508 111.309C18.8508 111.309 5.02083 106.219 1.38083 110.579C-2.25917 114.949 13.7509 120.769 24.6709 120.769C35.5909 120.769 52.6908 121.129 52.6908 121.129C52.6908 121.129 53.4209 114.569 49.3009 109.569Z",
    fill: "#F76707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9697 48.2495L53.7798 41.4395L50.5098 45.4395L57.0198 52.7195C57.0198 52.7195 58.1498 53.0795 61.0598 51.6295C63.9698 50.1695 63.9697 48.2495 63.9697 48.2495Z",
    fill: "#FFD8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.8699 48.7094L49.2999 46.0794C49.2999 46.0794 40.6799 47.2594 37.7699 46.5294C34.8599 45.7994 24.6699 43.6194 24.6699 42.8894C24.6699 42.1594 24.9399 40.7094 36.8099 41.4294C36.8099 41.4294 35.6099 40.6994 35.5999 39.2494C35.5899 37.7894 44.6799 39.2494 44.6799 39.2494C44.6799 39.2494 47.9599 37.7894 53.7799 41.4294L50.8699 48.7094Z",
    fill: "#FFA940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.7397 94.3794L76.6997 71.6394L62.5098 74.9094L71.9697 101.839L85.7397 94.3794Z",
    fill: "#FD7E14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.8912 71.6394H76.7012L85.4412 94.5594L87.8113 93.8294L78.8912 71.6394Z",
    fill: "#FFC078"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5098 86.9294L71.1897 100.609L66.0997 84.2194L62.5098 86.9294Z",
    fill: "#F76707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.9905 101.839L58.3405 90.3094L55.2305 92.8394L64.3605 103.639L68.9905 101.839Z",
    fill: "#F76707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.411 95.9094L59.411 105.599L55.0909 107.299L49.041 97.7794L51.411 95.9094Z",
    fill: "#F76707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.0807 112.509C91.0807 112.509 80.7108 112.029 78.5208 111.299C76.3408 110.569 59.6007 97.4694 52.3207 105.479C45.0407 113.489 45.7707 121.909 52.3207 124.979C58.8707 128.039 74.8808 125.859 74.8808 125.859C74.8808 125.859 90.1608 127.319 94.5308 125.129C98.9008 122.949 99.0008 121.489 99.0008 121.489C99.0008 121.489 87.8708 124.599 87.5608 120.859C87.2608 117.119 87.6307 113.719 91.0807 112.509Z",
    fill: "#FD7E14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.341 71.9994C110.341 71.9994 106.541 59.4394 100.361 53.8894L102.961 52.7094L110.351 58.8394L112.741 71.9893H110.341V71.9994Z",
    fill: "#F76707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.66 71.9994C105.66 71.9994 105.24 65.5794 97.1597 55.1494L92.1797 56.8194C92.1797 56.8194 98.4997 60.7194 101.06 71.9994H105.66Z",
    fill: "#F76707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.9805 72.5895C83.9805 72.5895 89.5204 63.7395 84.5704 58.9495L88.3505 57.9395C88.3505 57.9395 91.9905 64.3495 89.2905 71.9895L83.9805 72.5895Z",
    fill: "#F76707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.3102 67.4894C71.3102 67.4894 75.5701 66.9294 80.5001 58.7294L76.9901 56.2894C76.9901 56.2894 74.5201 60.7194 68.0801 64.5894L71.3102 67.4894Z",
    fill: "#F76707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.9502 57.2994C59.9502 57.2994 64.1202 56.9394 68.5902 50.4594L63.9702 47.2494C63.9702 47.2494 64.3302 52.7094 55.2402 53.0694L59.9502 57.2994Z",
    fill: "#F76707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.06 71.9994L96.0001 72.1294C96.0001 72.1294 94.2701 58.9794 90.5801 57.2994L92.1802 56.8094C92.1802 56.8194 99.2202 60.7194 101.06 71.9994Z",
    fill: "#FFC078"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.9707 70.7693C74.9707 70.7693 83.6407 66.9094 83.2607 59.2694L84.5807 58.9594C84.5807 58.9594 90.5407 64.3594 83.9907 72.5993C83.9807 72.5893 76.1407 72.8093 74.9707 70.7693Z",
    fill: "#FFC078"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.9904 56.2894L73.3704 53.7794C73.3704 53.7794 72.8103 58.5394 64.5703 61.4494L68.0803 64.5894C68.0803 64.5894 74.3704 62.0594 76.9904 56.2894Z",
    fill: "#FFC078"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.77 33.5494C118.77 33.5494 113.22 28.9793 110.58 33.0094C107.5 37.6994 114.34 40.6894 118.1 41.9294C119.53 42.3994 121.08 42.1294 122.27 41.2194C125.43 38.7994 130.92 33.6994 126.2 30.4394C122.37 27.7894 118.77 33.5494 118.77 33.5494Z",
    fill: "#FFA940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.18 35.6694C114.18 35.6694 116.23 38.8094 119.81 37.8194C123.32 36.8494 124.1 34.2294 124.1 34.2294C124.1 34.2294 120.68 38.3194 114.18 35.6694Z",
    fill: "#F76707",
    stroke: "#F76707",
    strokeWidth: 1.1304,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.361 60.7194C112.361 60.7194 117.562 62.3094 132.682 57.9494C140.742 55.6294 145.831 57.8094 145.831 57.8094L145.932 60.3094C145.932 60.3094 137.821 59.2694 131.641 61.4494C125.451 63.6294 117.361 65.4494 111.941 64.1794L112.361 60.7194Z",
    fill: "#FFC078"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.641 67.2694C111.641 67.2694 117.991 67.8494 127.121 66.6894C128.911 66.4594 130.691 66.0894 132.421 65.5494C135.851 64.4894 143.431 62.6794 149.151 65.2694L147.111 60.3994C147.111 60.3994 140.761 58.5394 132.031 61.4494C124.821 63.8494 111.651 64.3594 111.651 64.3594V67.2694H111.641Z",
    fill: "#F76707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.59 74.6695C112.59 74.6695 120.96 75.6395 130.56 72.3595C140.15 69.0895 152.29 69.9795 152.29 69.9795L156.35 74.1895C156.35 74.1895 140.02 72.3595 131.29 76.7295C126.33 79.2095 114.06 78.6895 114.06 78.6895L112.59 74.6695Z",
    fill: "#FFC078"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.82 82.2994C115.82 82.2994 122.55 83.2894 132.74 80.3694C142.93 77.4594 157.86 78.7494 157.86 78.7494L161.88 76.8894L157.11 73.5494C157.11 73.5494 141.461 73.8294 135.661 74.5494C129.841 75.2794 122.301 78.4694 114.061 78.6894L115.82 82.2994Z",
    fill: "#F76707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.041 85.0993C117.041 85.0993 132.681 81.5993 149.811 83.8993L143.661 87.8393C143.661 87.8393 128.751 88.2293 122.561 89.8293L117.041 85.0993Z",
    fill: "#F76707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.38 93.7094L145.6 89.3294C145.6 89.3294 145.84 86.4594 131.65 87.4194C117.46 88.3794 122.2 89.3294 122.2 89.3294L140.38 93.7094Z",
    fill: "#FFC078"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.35 96.0494C156.35 96.0494 164.04 99.2894 166.85 102.339V108.449L152.93 98.0694L156.35 96.0494Z",
    fill: "#FFC078"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.66 42.5294L139.66 42.1694C139.66 42.1694 125.61 56.8894 129.97 88.1894L134.49 90.4494C134.49 90.4394 127.71 64.4394 143.66 42.5294Z",
    fill: "#D9480F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.621 115.999C114.621 115.999 133.831 133.139 148.381 129.499C162.941 125.859 166.571 107.669 166.571 107.669L152.922 98.0894L113.451 85.1094C111.271 85.1094 86.5215 106.209 86.5215 106.209C86.5215 106.209 91.6114 107.669 93.0714 112.029C94.5314 116.399 98.8915 121.489 101.802 121.489L122.182 112.759L122.841 100.389",
    fill: "#FFA940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.7611 95.1694L97.8111 96.7394C97.8111 96.7394 96.3511 101.469 114.551 116.029L115.431 115.649C115.431 115.649 104.631 107.059 99.7611 95.1694Z",
    fill: "#FFC078"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.381 92.4994L146.111 88.6294L151.161 95.1694L143.661 98.7894L140.381 92.4994Z",
    fill: "#FFD8A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.6 90.2295L138.92 91.6495L131.64 88.7395C131.64 88.7395 126.96 86.9195 126.55 88.0095C126.14 89.0995 131.07 91.6495 131.07 91.6495C131.07 91.6495 128.01 93.1095 125.82 94.5595C123.64 96.0195 125.25 98.4895 127.36 97.6095C129.46 96.7395 133.1 95.2795 133.1 95.2795L130.34 98.4495L125.82 101.099C125.82 101.099 124.36 103.279 126.55 104.009C126.55 104.009 125.18 104.969 125.86 106.669C126.55 108.369 129.61 106.669 129.61 106.669C129.61 106.669 128 107.639 129.46 108.369C130.92 109.099 141.83 103.999 143.29 100.359H145.47C145.47 100.359 146.2 96.7195 144.14 93.7095C142.38 91.1695 140.6 90.2295 140.6 90.2295Z",
    fill: "#F76707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.821 49.4394L125.101 39.2494C125.101 39.2494 132.801 55.5394 127.711 66.6994L117.831 54.5494L111.282 66.1794C111.282 66.1794 106.191 55.2594 109.821 42.1594L117.821 49.4394Z",
    fill: "#D9480F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.91 55.6294H117.45C117.45 55.6294 115.88 50.1094 117.39 48.8694L118.18 49.0794C118.19 49.0794 118.2 54.2194 118.91 55.6294Z",
    fill: "#F76707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.55 116.029C114.55 115.299 97.8099 101.109 97.8099 96.7394L86.1699 105.839C86.1699 105.839 90.2899 107.929 91.2599 110.209C92.0999 112.189 96.9899 121.789 101.4 122.189L114.55 116.029Z",
    fill: "#FD7E14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.801 55.9294C145.381 61.2594 150.211 70.1794 159.311 77.8194L141.121 89.4594C141.121 89.4594 148.401 93.8294 148.401 100.379L174.691 86.0694C176.191 85.2494 177.001 83.5694 176.681 81.8894C175.371 74.9394 170.891 56.8994 158.591 46.9194C153.521 42.8094 149.921 44.4494 147.661 46.8594C145.381 49.2794 144.441 52.6394 144.801 55.9294Z",
    fill: "#FFA940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.752 53.7794C144.752 53.7794 147.992 45.5594 157.102 45.8594C157.102 45.8594 152.392 42.6294 148.752 45.8494C145.112 49.0794 144.752 53.7794 144.752 53.7794Z",
    fill: "#F76707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.281 61.1394C146.281 61.1394 149.531 48.8794 162.971 51.1594L166.411 55.6194C166.411 55.6194 158.181 51.7194 148.001 64.5894L146.281 61.1394Z",
    fill: "#F76707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.562 68.5094C150.562 68.5094 154.052 58.5294 168.872 59.6194L166.422 55.6194C166.422 55.6194 162.592 52.7094 155.312 56.3494C147.782 60.1194 148.032 64.3594 148.032 64.3594L150.562 68.5094Z",
    fill: "#FFC078"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.19 72.9394C154.19 72.9394 153.741 64.7294 171.621 65.2694L173.601 70.3894C173.601 70.3894 162.541 67.7394 157.101 75.8694L154.19 72.9394Z",
    fill: "#F76707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.302 77.8194C159.302 77.8194 161.342 72.6594 175.062 75.0594L173.602 70.3894C173.602 70.3894 161.092 67.7394 157.102 75.8694L159.302 77.8194Z",
    fill: "#FFC078"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.301 77.8194C159.301 77.8194 168.281 73.3294 175.071 79.3394C176.191 80.3294 176.821 81.8094 176.641 83.2994C176.511 84.3894 176.021 85.5294 174.671 86.0694C174.681 86.0694 176.041 77.0894 159.301 77.8194Z",
    fill: "#F76707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.411 87.6594C171.411 87.6594 166.951 79.6394 157.861 78.7494L159.311 77.8194C159.311 77.8194 175.141 76.4894 174.681 86.0694L171.411 87.6594Z",
    fill: "#FFC078"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.622 81.4594C153.622 81.4594 162.652 81.3694 166.622 90.4294L161.882 93.0394C161.882 93.0394 159.662 83.8094 150.932 83.1794L153.622 81.4594Z",
    fill: "#F76707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.411 95.4694L161.871 93.0394C161.871 93.0394 159.651 83.8094 150.921 83.1794L148.531 84.7094C148.541 84.7094 157.341 85.8294 157.411 95.4694Z",
    fill: "#FFC078"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.391 100.379L152.931 98.0694C152.931 98.0694 154.951 91.9494 144.571 87.2494L141.111 89.4594C141.111 89.4694 147.301 92.7394 148.391 100.379Z",
    fill: "#F76707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.59 34.5894C119.794 34.5894 120.77 33.6134 120.77 32.4094C120.77 31.2054 119.794 30.2294 118.59 30.2294C117.386 30.2294 116.41 31.2054 116.41 32.4094C116.41 33.6134 117.386 34.5894 118.59 34.5894Z",
    fill: "#D9480F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.87 31.0394C117.87 31.0394 116.77 31.3294 117.12 32.4194",
    stroke: "#FD7E14",
    strokeWidth: 0.3639,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.43 26.7494C125.29 26.8994 125.98 26.0094 125.57 25.2394C125.04 24.2494 123.92 23.3594 121.59 23.8794C118.97 24.4694 118.34 26.4594 118.27 28.0394C118.24 28.7194 119.1 29.0594 119.53 28.5294C120.16 27.7494 121.03 26.9394 122.02 26.7494C122.88 26.5794 123.73 26.6394 124.43 26.7494Z",
    fill: "#FFA940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.59 28.3994C109.79 28.7394 108.91 28.0494 109.13 27.1994C109.42 26.1094 110.29 24.9794 112.68 24.9394C115.36 24.8994 116.45 26.6794 116.88 28.1994C117.07 28.8594 116.31 29.3894 115.77 28.9694C114.97 28.3594 113.94 27.7794 112.93 27.8194C112.05 27.8694 111.24 28.1194 110.59 28.3994Z",
    fill: "#FFA940"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.04 28.0394C122.664 28.0394 123.17 27.5335 123.17 26.9094C123.17 26.2853 122.664 25.7794 122.04 25.7794C121.416 25.7794 120.91 26.2853 120.91 26.9094C120.91 27.5335 121.416 28.0394 122.04 28.0394Z",
    fill: "#D9480F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.001 29.1694C113.625 29.1694 114.131 28.6635 114.131 28.0394C114.131 27.4153 113.625 26.9094 113.001 26.9094C112.377 26.9094 111.871 27.4153 111.871 28.0394C111.871 28.6635 112.377 29.1694 113.001 29.1694Z",
    fill: "#D9480F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.091 26.1694L102.921 27.9694C102.911 27.8894 102.901 27.8194 102.891 27.7394C102.021 20.4494 107.271 13.7494 114.511 12.8894C121.751 12.0294 128.431 17.3094 129.291 24.5994L116.091 26.1694Z",
    fill: "#F76707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.868 15.9569C119.456 15.2911 123.717 12.4885 123.384 9.697C123.052 6.90555 118.252 5.18235 112.664 5.84812C107.075 6.51389 102.815 9.31651 103.147 12.108C103.48 14.8994 108.279 16.6226 113.868 15.9569Z",
    fill: "#D9480F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.717 14.4975C119.306 13.8317 123.567 11.0291 123.234 8.23765C122.901 5.4462 118.102 3.723 112.513 4.38877C106.925 5.05453 102.664 7.85716 102.997 10.6486C103.329 13.4401 108.129 15.1633 113.717 14.4975Z",
    fill: "#FD7E14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.101 8.8694L118.501 5.4494C118.081 3.0494 115.151 1.5594 111.961 2.1194C108.771 2.6794 106.521 5.0694 106.931 7.4694L107.521 10.8394C107.521 10.8494 107.521 10.8594 107.521 10.8694C107.521 10.8794 107.531 10.8894 107.531 10.8994V10.9094V10.9194C107.771 11.9094 110.471 12.2794 113.621 11.7394C116.751 11.2094 119.161 9.9694 119.091 8.9594C119.101 8.9194 119.111 8.8894 119.101 8.8694Z",
    fill: "#D9480F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.09 8.93946C119.09 8.93946 124.85 1.96946 133.35 6.07946",
    stroke: "#D9480F",
    strokeWidth: 0.5456,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8906 105.699C20.8906 105.699 33.3106 111.289 33.3206 106.829C33.3406 102.319 29.9906 93.4394 28.6406 96.9794C25.9706 104.009 28.7906 105.699 34.4506 106.829C40.1006 107.959 47.4407 98.1594 45.1807 107.299C42.9207 116.439 33.3206 106.829 33.3206 106.829C33.3206 106.829 32.7806 112.759 36.7106 114.739",
    stroke: "#D9480F",
    strokeWidth: 0.5652,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.6196 114.679C71.6196 114.679 68.4096 116.839 70.6496 120.309",
    stroke: "#D9480F",
    strokeWidth: 0.5652,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.9713 115.299C74.9713 115.299 72.3113 117.969 74.2913 120.309",
    stroke: "#D9480F",
    strokeWidth: 0.5652,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.1409 116.029C78.1409 116.029 76.6109 117.969 78.1409 120.309",
    stroke: "#D9480F",
    strokeWidth: 0.5652,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.2804 106.829C76.2804 111.349 80.9004 118.089 83.0604 118.129C87.8204 118.229 94.2504 112.349 86.5304 109.569C79.9004 107.179 82.6503 115.079 83.9803 121.689C85.3203 128.299 75.0704 128.399 81.9304 119.259C85.3204 114.739 70.6504 122.689 70.6504 122.689",
    stroke: "#D9480F",
    strokeWidth: 0.5652,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.1001 104.599C66.1001 104.599 54.1401 95.8394 47.6901 107.549C41.2301 119.259 48.6802 129.429 61.9102 126.609C75.1402 123.789 66.1001 104.599 66.1001 104.599Z",
    fill: "#F76707"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6713 119.829C14.6713 119.829 19.1913 111.919 13.5413 109.659C7.89131 107.399 0.621259 108.249 0.861259 111.779C1.10126 115.309 2.24132 116.439 14.6713 119.829Z",
    fill: "#D9480F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7112 116.439C49.7112 116.439 48.5812 123.219 58.7512 123.219",
    stroke: "#FFA940",
    strokeWidth: 0.5652,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3516 109.569C12.3516 109.569 16.2516 115.289 12.3516 116.149",
    stroke: "#F76707",
    strokeWidth: 0.5652,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.381 2.02937C134.381 2.67937 133.211 6.49937 133.211 6.49937C133.211 6.49937 132.041 2.67937 132.041 2.02937C132.041 1.37937 132.561 0.859375 133.211 0.859375C133.861 0.859375 134.381 1.38937 134.381 2.02937Z",
    fill: "#D9480F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.23 2.32935C131.65 2.82935 133.21 6.50935 133.21 6.50935C133.21 6.50935 129.86 4.32935 129.44 3.83935C129.02 3.34935 129.09 2.60935 129.58 2.18935C130.07 1.76935 130.82 1.82935 131.23 2.32935Z",
    fill: "#D9480F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.01 4.56943C129.65 4.67943 133.21 6.49943 133.21 6.49943C133.21 6.49943 129.24 6.98943 128.6 6.87943C127.96 6.76943 127.54 6.15943 127.65 5.51943C127.77 4.88943 128.37 4.45943 129.01 4.56943Z",
    fill: "#D9480F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.749 7.71939C129.309 7.39939 133.209 6.49939 133.209 6.49939C133.209 6.49939 130.479 9.42939 129.919 9.74939C129.359 10.0694 128.639 9.87939 128.319 9.31939C127.999 8.75939 128.189 8.04939 128.749 7.71939Z",
    fill: "#D9480F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.58 10.2994C130.8 9.68939 133.21 6.49939 133.21 6.49939C133.21 6.49939 133.001 10.4894 132.781 11.0994C132.561 11.7094 131.891 12.0194 131.281 11.7994C130.671 11.5794 130.36 10.9094 130.58 10.2994Z",
    fill: "#D9480F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.641 11.0994C133.421 10.4894 133.211 6.49939 133.211 6.49939C133.211 6.49939 135.621 9.68939 135.841 10.2994C136.061 10.9094 135.751 11.5794 135.141 11.7994C134.531 12.0194 133.861 11.7094 133.641 11.0994Z",
    fill: "#D9480F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.501 9.74939C135.941 9.42939 133.211 6.49939 133.211 6.49939C133.211 6.49939 137.111 7.39939 137.671 7.71939C138.231 8.03939 138.421 8.75939 138.101 9.31939C137.771 9.87939 137.061 10.0694 136.501 9.74939Z",
    fill: "#D9480F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.821 6.87937C137.181 6.98937 133.211 6.49937 133.211 6.49937C133.211 6.49937 136.771 4.67937 137.411 4.56937C138.051 4.45937 138.651 4.87937 138.771 5.51937C138.881 6.15937 138.451 6.76937 137.821 6.87937Z",
    fill: "#D9480F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.981 3.82934C136.561 4.32934 133.211 6.49934 133.211 6.49934C133.211 6.49934 134.771 2.81934 135.191 2.31934C135.611 1.81934 136.341 1.75934 136.841 2.17934C137.341 2.59934 137.401 3.32934 136.981 3.82934Z",
    fill: "#D9480F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.381 2.02937C134.381 2.67937 133.211 6.49937 133.211 6.49937C133.211 6.49937 132.041 2.67937 132.041 2.02937C132.041 1.37937 132.561 0.859375 133.211 0.859375C133.861 0.859375 134.381 1.38937 134.381 2.02937Z",
    fill: "#D9480F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.21 7.65935C133.922 7.65935 134.5 7.08179 134.5 6.36935C134.5 5.6569 133.922 5.07935 133.21 5.07935C132.497 5.07935 131.92 5.6569 131.92 6.36935C131.92 7.08179 132.497 7.65935 133.21 7.65935Z",
    fill: "#FFD8A8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircusRightImage);
export default __webpack_public_path__ + "static/media/circusRightImage.9993bebc9e3d154fe92516cdfd665119.svg";
export { ForwardRef as ReactComponent };